import { Link } from "react-router-dom"
import { ROOT } from "../../routes/routes_name"
import useGalleryInfografis from "./useGalleryInfografis"

const GalleryInfografisPage = () => {
    const {
        page,
        totalPage,
        dataInfografis,
        isLoadingInfografis,
        setPage,
        getThumbnailImage,
    } = useGalleryInfografis()

    return (
        <div id="body" className="index-page">
            <header id="header" className="header d-flex align-items-center fixed-top">
                <div className="header-container container-fluid container-xl position-relative d-flex align-items-center justify-content-between py-3">
                    <a href={ROOT} className="logo d-flex align-items-center me-auto me-xl-0">
                        <h1 className="sitename"><img src="assets/img/ppg.png" alt="" srcSet="" /></h1>
                    </a>
                    <Link to={ROOT} className="btn-getstarted"><i className="bi bi-chevron-left"></i> Kembali</Link>
                </div>
            </header>
            <main className="main">
                <div className="page-title light-background">
                    <div className="container">
                        <h1>Galeri Infografis</h1>
                        <nav className="breadcrumbs">
                            <ol>
                                <li><a href={ROOT}>Home</a></li>
                                <li className="current">Galeri Infografis</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <div id="gallery-video" className="gallery section">
                    <div className="container">
                        <div className="row p-3 border rounded-4 m-1">
                            {
                                isLoadingInfografis ? <div className="text-center">Loading...</div> :
                                    !dataInfografis ? <div className="text-center">Data tidak ditemukan</div> :
                                        dataInfografis.map((d, i) => {
                                            return (
                                                <div key={i} className="col-xl-3 col-lg-3 col-md-6 col-sm-6 my-2" style={{ position: "relative", display: "inline-block" }}
                                                    data-aos="fade-up" data-aos-delay="200">
                                                    <a href={d.file} className="glightbox">
                                                        <img src={d.file} className="w-100 rounded-4" alt="" />

                                                    </a>
                                                </div>
                                            )
                                        })
                            }
                        </div>
                        <div className="pagination-container w-100 my-4" data-aos="fade-up" data-aos-delay="200">
                            <nav aria-label="Page Navigation">
                                <ul className="pagination justify-content-center">
                                    <li className={`page-item ${page === 1 ? "disabled" : ""}`} onClick={() => {
                                        if (page !== 1) {
                                            setPage(page - 1)
                                        }
                                    }
                                    }>
                                        <a className="page-link">Previous</a>
                                    </li>
                                    {
                                        Array.from({ length: totalPage }).map((_, index) => (
                                            <li key={index} onClick={() => setPage(index + 1)} className={`page-item ${page === index + 1 ? "active" : ""}`}><a className="page-link" href="#">{index + 1}</a></li>
                                        ))
                                    }
                                    <li className={`page-item ${page === totalPage ? "disabled" : ""}`} onClick={() => {
                                        if (page !== totalPage) {
                                            setPage(page + 1)
                                        }
                                    }
                                    }>
                                        <a className="page-link" href="#">Next</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    )
}
export default GalleryInfografisPage